import {
  SUBLEAGUE_CLOSE,
  SUBLEAGUE_LIST_CLOSE,
  SUBLEAGUE_SET,
  SUBLEAGUE_SET_LIST,
  SUBLEAGUE_SET_LIST_OWN,
} from "./subleaguesActions";
import { RANKING_SET } from "../Ranking/rankingReducer";

export const subleaguesReducer = (
  state = {
    openList: false,
    openEntries: false,
    type: null,
    current: null,
    list: [],
    ownSubleagues: [],
    listColumns: [],
    entries: [],
    entriesColumns: [],
    showMoreButton: false,
  },
  action
) => {
  switch (action.type) {
    case RANKING_SET:
      return {
        ...state,
        openList: false,
        openEntries: false,
      };
    case SUBLEAGUE_SET_LIST:
      return {
        ...state,
        openList: true,
        openEntries: false,
        type: action.payload.type,
        list: action.payload.entries,
        listColumns: action.payload.columns,
        ownSubleagues: null,
      };
    case SUBLEAGUE_SET_LIST_OWN:
      return {
        ...state,
        ownSubleagues: action.payload.own,
      };
    case SUBLEAGUE_SET:
      return {
        ...state,
        current: action.payload.subleague,
        openEntries: true,
        openList: false,
        entries: action.payload.entries,
        entriesColumns: action.payload.columns,
        showMoreButton: action.payload.showMoreButton,
      };
    case SUBLEAGUE_CLOSE:
      return { ...state, openEntries: false, openList: true };
    case SUBLEAGUE_LIST_CLOSE:
      return { ...state, openList: false };
    default:
      return state;
  }
};
